import { PersonPersonTypeEnum } from "src/app/shared/Models/enums/PersonPersonTypeEnum";
import { PersonLanguageEnum } from "src/app/shared/Models/enums/PersonLanguageEnum";

export class ChangeDocumentContact {
  id: string;
  name: string;
  phone: string;
  email: string;
  language: PersonLanguageEnum;
  type: PersonPersonTypeEnum;

  constructor(command: Partial<ChangeDocumentContact>) {
    Object.assign(this, command);
  }
}
